import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.styl';

const defaultIconCode = '345';

const NextStepsList = ({ title, items, linkComponent, linkProps }) => {
  const Link = linkComponent;

  return (
    <Fragment>
      <h5 className={styles.title}>{title}</h5>
      <ul className={styles.list}>
        {items.map(item => (
          <Link
            key={item.href}
            href={item.href}
            className={styles.listItemLink}
            {...linkProps}
          >
            <li className={styles.listItem}>
              <span className={`icon icon-budicon-${item.icon || defaultIconCode} ${styles.icon}`} />
              <span className={styles.text}>{item.text}</span>
            </li>
          </Link>
        ))}
      </ul>
    </Fragment>
  );
};

NextStepsList.defaultProps = {
  linkProps: {}
};

NextStepsList.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    icon: PropTypes.number,
    href: PropTypes.string.isRequired
  })).isRequired,
  linkComponent: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.string
  ]).isRequired,
  linkProps: PropTypes.object
};

export default NextStepsList;
